import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from 'dibs-react-tooltip';
import InfoIcon from 'dibs-vg/dist/react/info-circle';
import InfoFilledIcon from 'dibs-vg/dist/react/info-circle-filled';
import { shipping } from './verifiedTradePromoConstants.es';
import style from './VerifiedTradePromo.scss';

class VerifiedTradePromoInfo extends Component {

    constructor() {
        super();

        this.state = {
            isVisible: false
        };

        this._setVisibility = this._setVisibility.bind(this);
    }

    _setVisibility(isVisible) {
        this.setState({isVisible});
    }

    render() {
        const { tooltipDirection } = this.props;
        const { isVisible } = this.state;
        const { texts, link } = shipping.tooltip;
        const IconView = isVisible ? InfoFilledIcon : InfoIcon;

        return (
            <div className={style.infoContainer} onMouseEnter={() => this._setVisibility(true)} onMouseLeave={() => this._setVisibility(false)}>
                <IconView className={style.infoIcon} />
                <Tooltip
                    isVisible={isVisible}
                    className={classNames(style.tooltip, style[tooltipDirection])}
                    containerClass={style.tooltipInner}
                    tooltipDirection={tooltipDirection}
                >
                    {texts.MAIN} <a href={link.URL} target="_blank">{link.TEXT}</a> {texts.END}
                </Tooltip>
            </div>
        );
    }
}

VerifiedTradePromoInfo.propTypes = {
    tooltipDirection: PropTypes.string
};

export default VerifiedTradePromoInfo;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/VerifiedTradePromo/VerifiedTradePromoInfo.jsx